import $ from 'jquery'
import configurations from '../../../helpers/misc/configurations'
import {
	t,
} from '../../../helpers/global'
import { Map, fromJS } from 'immutable'
export const requiredCase = value => value ? undefined : ` is required`
// export const requiredCase = (value,name) => {
// 	console.log(value, 'value requiredCase')
// 	console.log(name, 'name requiredCase')
// }
const validate = (values,props) => {
	const job = props.publicJobDetail.job || {}
	
	let document_list = []
	if (job.document_list) {
		document_list = JSON.parse(job.document_list)
	}
	const emailRequired = job.email_required 
	const errors = {}

	// console.log(document_list,'divalidator')
	// console.log(values,'values di validator')

	document_list.map((value,index)=>{
		let valuestring = value.type.replace(/\./g,' ')
		// console.log(valuestring)
		if (value.option_value == 2) {
			if(!values[valuestring] || values[valuestring].trim() ===''){
				errors[valuestring]=`${value.type} REQUIRED_LANDING_PAGE`
			}
		}
		
	})

	

	
	console.log(errors,'erros')
	return errors
}

export default validate
